import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { PayrollDeductionCompartments, payrollDeductionStorageKey } from '..';

export class DeductionsListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.GroupFeatureMapInitialized)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(payrollDeductionStorageKey)
    private readonly cache: DataCache<PayrollDeductionCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('deductions');
        } else {
          this.cache.reset('deductions');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
